/* Balkan — feedback la adăugarea în coș din cardurile paginii principale.

   `product-form-component` al temei trimite cererea și actualizează starea coșului
   (bulina din header), dar nu deschide sertarul: asta o face `quick-add-component`,
   pe care nu-l folosim (își impune propriul layout peste imaginea cardului).
   Aici așteptăm ca bulina să se schimbe — semnul că adăugarea a reușit — și apoi
   deschidem sertarul prin butonul din header, singurul API public al temei. */
(() => {
  if (window.__balkanCart) return;
  window.__balkanCart = true;

  const TOGGLE = '[aria-controls="cart-drawer"]';
  const BUBBLE = '#cart-bubble-text, .cart-bubble';

  const openDrawer = () => {
    const btn = document.querySelector(TOGGLE);
    if (btn && btn.getAttribute('aria-expanded') !== 'true') btn.click();
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    /* ⚠️ Acoperim TOATE formularele de adăugare, nu doar cardurile.
       Prima versiune filtra pe `.bk-pc, .bk-hl__buy, .bk-mini`, deci pe pagina de
       produs — unde e formularul principal și bara lipită — bulina se actualiza,
       dar sertarul nu se deschidea: adăugarea părea fără efect.
       Singura excepție rămâne `quick-add-component`, care își deschide singur
       sertarul; dublura e oricum prinsă de garda `aria-expanded` din openDrawer. */
    if (form.closest('quick-add-component')) return;

    const bubble = document.querySelector(BUBBLE);
    /* Coș gol = bulina nu există încă în DOM. Fără asta, primul produs adăugat
       nu deschidea niciodată sertarul — exact cazul unui vizitator nou. */
    if (!bubble) { setTimeout(openDrawer, 900); return; }

    const before = bubble.textContent.trim();
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      obs.disconnect();
      clearTimeout(timer);
      openDrawer();
    };
    const obs = new MutationObserver(() => {
      if (bubble.textContent.trim() !== before) finish();
    });
    obs.observe(bubble, { childList: true, characterData: true, subtree: true });
    // plasă de siguranță: dacă bulina nu se schimbă (era deja aceeași cantitate),
    // deschidem oricum sertarul, ca acțiunea să nu pară fără efect
    const timer = setTimeout(finish, 2500);
  });
})();

/* ── Clic pe voal = închide sertarul (6 oct. 2026) ─────────────────────────
   Voalul e un pseudo-element al lui `.page-wrapper`, deci nu i se poate pune
   direct un ascultător. Nu e nevoie: un clic pe el raportează ca țintă chiar
   `.page-wrapper`, pe când un clic pe conținut raportează elementul de
   conținut. Deci egalitatea strictă `e.target === wrapper` distinge exact
   clicul pe voal de clicul pe pagină — fără să închidem sertarul din greșeală
   când cineva apasă pe un produs. */
(() => {
  if (window.__bkScrim) return;
  window.__bkScrim = true;
  document.addEventListener('click', (e) => {
    const wrap = document.querySelector('.page-wrapper--drawer-open');
    if (!wrap || e.target !== wrap) return;
    const d = [...document.querySelectorAll('dialog.theme-drawer__dialog')]
      .find((x) => x.open && x.getBoundingClientRect().width > 0);
    if (!d) return;
    const inchide = d.querySelector('.theme-drawer__close-button');
    if (inchide) inchide.click();
    else if (typeof d.close === 'function') d.close();
  });
})();
